import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useApi, formatPrice } from '../../lib/api';

type Stats = {
  active_listings: number;
  sales_count: number;
  gmv_cents: number;
  fees_cents: number;
  active_sellers: number;
};

export default function AdminDashboard() {
  const api = useApi();
  const [stats, setStats] = useState<Stats | null>(null);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    api<{ stats: Stats }>('/admin/stats')
      .then(({ stats }) => setStats(stats))
      .catch((e) => setErr(e.message));
  }, [api]);

  return (
    <section>
      <h2>Admin</h2>
      {err && <p style={{ color: 'crimson' }}>{err}</p>}
      {stats && (
        <div className="grid cols-3">
          <div className="card">
            <h3>Active listings</h3>
            <p className="price">{stats.active_listings}</p>
          </div>
          <div className="card">
            <h3>GMV</h3>
            <p className="price">{formatPrice(stats.gmv_cents)}</p>
          </div>
          <div className="card">
            <h3>Platform fees</h3>
            <p className="price">{formatPrice(stats.fees_cents)}</p>
          </div>
          <div className="card">
            <h3>Active sellers</h3>
            <p className="price">{stats.active_sellers}</p>
          </div>
          <div className="card">
            <h3>Sales</h3>
            <p className="price">{stats.sales_count}</p>
          </div>
        </div>
      )}
      <div style={{ marginTop: '1.5rem', display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
        <Link to="/admin/applications" className="btn">
          Applications
        </Link>
        <Link to="/admin/seat-blocks" className="btn">
          Seat verification
        </Link>
        <Link to="/admin/listings" className="btn">
          Listings
        </Link>
        <Link to="/admin/sellers" className="btn">
          Sellers
        </Link>
        <Link to="/admin/games" className="btn">
          Games
        </Link>
        <Link to="/admin/disputes" className="btn">
          Disputes
        </Link>
      </div>
    </section>
  );
}
